function swapButton(e, widget) {
    const forms = [...widget.querySelectorAll('.js_silverbullet__form')];

    forms.filter(form => form.getAttribute('data-silverbullet-button-id') != e.target.value).map(form => form.classList.add('silverbullet__form--hidden'));

    forms.filter(form => form.getAttribute('data-silverbullet-button-id') == e.target.value).map(form => form.classList.remove('silverbullet__form--hidden'));
}

function initWidget(widget) {
    const options = widget.querySelectorAll('.js_silverbullet__option');

    options.forEach(option => option.addEventListener('change', e => swapButton(e, widget)));
}

function init() {
    const widgets = document.querySelectorAll('.js_silverbullet');

    widgets.forEach(initWidget);
}

$(document).ready(init);
